<template>
  <v-navigation-drawer
    app
    v-model="model"
    :mini-variant.sync="mini"
    :fixed="true"
    :disable-resize-watcher="true"
    class="i4pro-sidebar"
    v-bind="configSidebar"
  >
    <vue-perfect-scrollbar class="drawer--scroll" :settings="scrollSettings">
      <i4proLightboxSmall :mini="mini" @handleToggleExpandDrawer="handleToggleExpandDrawer" />

      <v-divider></v-divider>

      <v-list :class="['pt-0 pb-0', mini && 'i4pro-sidebar--mini']" dense>
        <v-list-group
          v-for="(item, i) in menu"
          :key="i"
          :id="`menu-${item.id}`"
          :append-icon="'children' in item ? 'zmdi zmdi-chevron-down' : ''"
          class="v-list-item--first"
          @click="handleLoadRoute(item)"
          :class="[getCurrentActiveMenu === item.id && 'active']"
          v-model="toggleDropdown[i]"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon class="icon-shake mr-2" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>

            <v-list-item-title v-text="item.name"></v-list-item-title>
          </template>

          <v-list-item class="v-list-item--dropdown" v-if="'children' in item">
            <i4proMenuDropdown class="i4pro-dropdown i4pro-dropdown--sidebar" :item="item" :mini="mini" />
          </v-list-item>
        </v-list-group>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { handleLoadRoute } from '@/helpers/page';

import store from '@/store';

export default {
  components: {
    VuePerfectScrollbar: () => import('vue-perfect-scrollbar'),
    i4proMenuDropdown: () => import('@/components/menus/i4pro-menu-dropdown'),
    i4proLightboxSmall: () => import('@/components/lightbox/i4pro-lightbox-small')
  },

  props: {
    model: { type: Boolean, default: false }
  },

  data: () => ({
    mini: false,
    toggleDropdown: {},
    scrollSettings: {
      maxScrollbarLength: 50,
      suppressScrollX: true
    }
  }),

  async created() {
    await store.dispatch('menu/getMenu');
  },

  methods: {
    handleLoadRoute,

    handleToggleExpandDrawer() {
      this.mini = !this.mini;
    }
  },

  computed: {
    getCurrentActiveMenu: () => store.getters['menu/currentActiveMenu'],

    menu: () => store.getters['menu/getMenu'],

    configSidebar: () => store.getters['layout/getConfigSidebar']
  },

  watch: {
    $route(to) {
      to.path === '/dashboard' && store.dispatch('menu/setCurrentActiveMenu', this.menu[0].id);
    },

    mini(newValue) {
      if (newValue) {
        for (var model in this.toggleDropdown) {
          this.toggleDropdown[model] = false;
        }
      }
    }
  }
};
</script>
